var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubMenu = function SvgSubMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.232 25.965H12.124V4.792a.3.3 0 0 0-.299-.299h-.93a.3.3 0 0 0-.299.299v22.402a.3.3 0 0 0 .3.3h14.336a.301.301 0 0 0 .301-.301v-.928a.301.301 0 0 0-.301-.301z"
  })));
};
export default SvgSubMenu;